import * as React from 'react'
import { useCallback, useMemo } from 'react'
import { Chip, Menu } from 'react-native-paper'
import { Text } from 'react-native'
import { ContributionStatus } from '../../../../generated/graphql'
import { useTranslation } from 'react-i18next'

interface NodeSelectorProps {
  selected?: ContributionStatus | 'All'
  onSelect: (value: ContributionStatus | 'All') => void
}

const states: { name: string; value: ContributionStatus | 'All' }[] = [
  { name: 'ALL', value: 'All' },
  { name: ContributionStatus.Pending, value: ContributionStatus.Pending },
  { name: ContributionStatus.Accepted, value: ContributionStatus.Accepted },
  { name: ContributionStatus.Rejected, value: ContributionStatus.Rejected },
]

export default function ContributionStatusSelector(props: NodeSelectorProps) {
  const [visible, setVisible] = React.useState(false)
  const { t } = useTranslation('contributions')
  const selectedName = useMemo(() => {
    const selectedStr = JSON.stringify(props.selected)
    return (
      states.find((s) => {
        return selectedStr == JSON.stringify(s.value)
      })?.name || ''
    )
  }, [props.selected])

  return (
    <Menu
      visible={visible}
      onDismiss={() => setVisible(false)}
      anchorPosition={'bottom'}
      anchor={
        <Chip
          mode="outlined"
          closeIcon={visible ? 'menu-up' : 'menu-down'}
          onPress={() => setVisible((prev) => !prev)}
          onClose={() => setVisible((prev) => !prev)}
        >
          <Text>{t(selectedName)}</Text>
        </Chip>
      }
    >
      {states.map((statusItem) => (
        <Menu.Item
          key={statusItem.name}
          onPress={() => {
            setVisible(false)
            props.onSelect(statusItem.value)
          }}
          title={t(statusItem.name)}
        />
      ))}
    </Menu>
  )
}
